import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement("path", { d: "M7 16a2 2 0 110 4 2 2 0 010-4zm10 0a2 2 0 110 4 2 2 0 010-4zM13 5a1 1 0 011 1v1.999L19.33 8a1 1 0 01.95.68l1.67 5c.03.1.05.21.05.32v3a1 1 0 01-1 1h-1a3 3 0 00-6-.03V18h-4a3 3 0 10-6 0H3a1 1 0 01-1-1V6a1 1 0 011-1h10zm5.61 5H16v3h3.61l-1-3z" })
);
export {
  t as default
};
